import EmptyNotifications from './EmptyNotifications';

export default EmptyNotifications;
